import React from 'react';
import './LuckyMinute.scss';

interface Props {
  large?: boolean;
}

export const Play60s = (props: Props) => {
  return (
    <div className={'play60s' + (props.large ? ' large' : '')}>
      <span className="first">娱乐60秒</span>
      <span className="second">play60s.com</span>
    </div>
  );
};
